var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMobileBottomBarCurve = function SvgMobileBottomBarCurve(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155px",
    height: "107px",
    viewBox: "0 0 155 107",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "BottomCurve",
    id: "Bars/Tabbar---5-Tab",
    transform: "translate(-110.000000, 0.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tabbar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,25.0039062 C143.896484,25.0039062 152.762207,13.5471191 161.087402,8.06469727 C169.412598,2.58227539 181.033203,0 187.557129,0 C194.081055,0 206.452148,3.17407227 213.10498,8.06469727 C219.757812,12.9553223 230.8125,25 264,25 C264.108073,34.2727865 264.108073,61.6061198 264,107 L110.966797,107 C110.988932,60.666748 111,33.3347168 111,25.0039062 Z",
    id: "Path-2"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileBottomBarCurve, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-bottom-bar-curve.214a023f.svg";
export { ForwardRef as ReactComponent };